export default __webpack_public_path__ + "static/media/logo-scinti-est.9b31df7a.svg";